import { render, staticRenderFns } from "./KqtCameraSync.vue?vue&type=template&id=664b012f&scoped=true"
import script from "./KqtCameraSync.vue?vue&type=script&lang=js"
export * from "./KqtCameraSync.vue?vue&type=script&lang=js"
import style0 from "./KqtCameraSync.vue?vue&type=style&index=0&id=664b012f&prod&scoped=true&lang=css"
import style1 from "./KqtCameraSync.vue?vue&type=style&index=1&id=664b012f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664b012f",
  null
  
)

export default component.exports